<template>
  <span class="material-design-icon access-point-network-icon"
        role="img">
    <svg class="material-design-icon__svg"
         :width="customWidth"
         :height="customHeight"
         viewBox="0 0 15500 15500"
         :fill="fillColor">
        <path d="M11712.26 988.05c357.51,0 650,292.49 650,649.99 0,357.51 -292.49,650.01 -650,650.01l-3303.84 -0.01 0 2647.3c1232.64,99.52 2319.72,477.72 3082.72,1026.52l849.85 -556.53c75.04,-49.58 207.37,-94.74 322.74,-94.74l2290.61 0c270.92,0 522.86,315.63 522.86,655.02l0 7922.55c0,312.89 -248.21,623.82 -497.96,623.82l-2390.2 0c-264.76,0 -1940.02,-1278.84 -2116.32,-1278.84l-2705.75 0 -33.98 0 -2705.75 0c-176.3,0 -1851.56,1278.84 -2116.32,1278.84l-2390.2 0c-249.75,0 -497.96,-310.93 -497.96,-623.82l0 -7922.55c0,-339.39 251.94,-655.02 522.86,-655.02l2290.61 0c115.37,0 247.7,45.16 322.74,94.74l857.66 561.64c763.75,-551.86 1854.51,-932.21 3091.79,-1031.79l0 -2647.13 -3303.85 0c-357.51,0 -650,-292.5 -650,-650.01 0,-357.5 292.49,-649.99 650,-649.99l7907.69 0z"/>
    </svg>
  </span>
</template>

<script>
  export default {
    name: "eqp-icon",
    props: ['fillColor', 'customWidth', 'customHeight']
  }
</script>

<style scoped>
</style>
